import axiosInstance from "src/services/axiosInstance.js";
import { getStoredValue } from "src/services/logics.js";
import { isChunkLoadError } from "src/utils/isChunkLoadError.js";

export const buildErrorContext = location => ({
  route: {
    pathname: location?.pathname || window.location.pathname,
    search: location?.search || window.location.search,
    hash: location?.hash || window.location.hash,
    href: window.location.href,
  },
  session: {
    user_id: getStoredValue("id") || undefined,
    user_email: getStoredValue("email") || undefined,
    store_id: getStoredValue("storeid") || undefined,
  },
});

export const postNotify = async (error, { componentStack, extra = {}, location } = {}) => {
  if (isChunkLoadError(error)) return;

  const context = { ...buildErrorContext(location), ...extra };

  try {
    await axiosInstance.post("/api/v1/notify", {
      error: error.message || "Unknown error",
      stack: componentStack || error.stack || "No stack trace",
      alertType: error.name || "Error",
      project: "Service-points-frontend",
      context,
    });
  } catch (_) {
    console.error("Failed to send error to notify endpoint");
  }
};
